<template lang="pug">
v-dialog(
  v-model="visibility"
  :persistent="isPersistent"
  :content-class="`${!hasScroll && 'overflow-y-hidden'} ${contentClass}`"
  :max-width="maxWidth")
  v-card(:style="{padding: modalPadding}" :class="modalClass")
    v-snackbar(v-model="snackbarVisibility" :timeout="timeout" top) {{ $t('misc.copied') }}
    v-toolbar(flat :height="toolbarHeight" :style="{top: toolbarTopPosition}")
      v-spacer
      v-btn(icon v-if="isCloseIcon" @click="visibility = false")
        v-icon mdi-close
    v-card-text.py-0.px-0(style="text-align: center")
      div(v-if="modalTitleIcon")
        v-icon(:size="iconSize") {{ modalTitleIcon }}
      div(v-if="modalTitle" :style="{'margin-top': modalHeadingMarginTop, 'margin-bottom': modalHeadingMarginBottom}")
        //- div.d-flex.align-center.justify-center
          //- v-icon(size="48").mr-2 {{ modalTitleIconInnerText }}
        h2.favorite_modal_heading(:style="{'font-size': modalTitleFontSize, 'font-weight': modalTitleFontWeight}") {{ modalTitle }}
        p.favorite_modal_description.mb-0(
            v-if="modalDescription"
            :style="{'font-size': modalDescriptionFontSize,'margin-top': modalDescriptionMarginTop, 'margin-bottom': modalDescriptionMarginBottom, 'color': modalDescColor}"
            v-html="modalDescription")
      slot(name="modalBody")
</template>

<script>
export default {
  /* This dialog modal component is added to show edit, delete, create actions.
  You also can use this component to show information. */
  name: 'AppDialogModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    isPersistent: {
      type: Boolean,
      default: true,
    },
    contentClass: {
      type: String,
      default: '',
    },
    isCloseIcon: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: Number,
      default: 480,
    },
    modalPadding: {
      type: String,
      default: '1.5rem',
    },
    modalClass: {
      type: String,
      default: '',
    },
    toolbarHeight: {
      type: String,
      default: '.9375rem',
    },
    toolbarTopPosition: {
      type: String,
      default: '.3125rem',
    },
    iconSize: {
      type: String,
      default: '3.75rem',
    },
    modalTitleIcon: {
      type: String,
      default: '',
    },
    modalTitleIconInnerText: {
      type: String,
      default: '',
    },
    modalHeadingMarginTop: {
      type: String,
      default: '1.5rem',
    },
    modalHeadingMarginBottom: {
      type: String,
      default: '0',
    },
    modalTitle: {
      type: String,
      default: '',
    },
    modalTitleFontSize: {
      type: String,
      default: '1.125rem',
    },
    modalTitleFontWeight: {
      type: String,
      default: '500',
    },
    modalDescription: {
      type: String,
      default: '',
    },
    modalDescriptionFontSize: {
      type: String,
      default: '.875rem',
    },
    modalDescriptionMarginTop: {
      type: String,
      default: '.625rem',
    },
    modalDescriptionMarginBottom: {
      type: String,
      default: '',
    },
    modalDescriptionPadding: {
      type: String,
      default: '',
    },
    isSnackbarVisible: {
      type: Boolean,
      default: false,
    },
    modalDescColor: {
      type: String,
      default: '#262626',
    },
    hasScroll: Boolean,
  },
  data: () => ({
    timeout: 1000,
  }),
  computed: {
    visibility: {
      get() {
        return this.isVisible;
      },
      set(value) {
        this.$emit('update:isVisible', value);
      },
    },
    snackbarVisibility: {
      get() {
        return this.isSnackbarVisible;
      },
      set(value) {
        this.$emit('update:isSnackbarVisible', value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/components/appDialogModal.scss';
</style>
